import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import CommonTable from '../../common/components/CommonTable';
import EditDealerNotesTableRow from './EditDealerNotesTableRow';

const headers = [
  {
    label: 'Date',
  },
  {
    label: 'Author',
  },
  {
    label: 'Note',
  },
];

function EditDealerNotesTable({ data, offset, changeOffset = () => {}, forceShow }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (forceShow) {
      setShow(forceShow.show);
    }
  }, [forceShow]);

  return (
    <>
      <Button
        className="rounded-pill btn-light w-100 mb-2"
        type="button"
        onClick={() => setShow((prev) => !prev)}
      >
        Notes {show ? '-' : '+'}
      </Button>
      {show && (
        <Row>
          <Col xs="12">
            <CommonTable
              rowComponent={EditDealerNotesTableRow}
              data={data}
              offset={offset}
              onOffsetChange={changeOffset}
              headers={headers}
              pagination={true}
              hasRowPointer={false}
            />
          </Col>
        </Row>
      )}
    </>
  );
}

export default EditDealerNotesTable;
